
export default {
  computed: {
    email () {
      const domain = this.$store.state.siteBrand
      const tld = this.$store.state.site.replace(new RegExp(`.*${domain}`), '')

      return ['mailto:contact@', domain, tld].join('')
    }
  }
}
